import React from "react";
import { PartsTable } from "./NpdShared";

const DevelopmentTracker = ({ app, lineId }) => {
  const { isAdmin, me, lines, parts, buyers, today, go, openPart, advance } = app;
  const L = lines.find((l) => String(l.id) === String(lineId)) || lines[0];
  if (!L) {
    return (
      <>
        <h2>Development Tracker</h2>
        <div className="panel empty">No assembly lines yet.</div>
      </>
    );
  }
  const lp = parts.filter((p) => p.L.id === L.id);
  // A buyer's table lists only their own parts, so the line counts count only those too
  const counted = isAdmin ? parts : parts.filter((p) => p.buyerId === me?.orgUserId);
  const pre = (
    <select value={L.id} onChange={(e) => go("tracker", { line: e.target.value })}>
      {lines.map((l) => (
        <option key={l.id} value={l.id}>{l.name} ({counted.filter((p) => p.L.id === l.id).length} parts)</option>
      ))}
    </select>
  );

  return (
    <>
      <h2>Development Tracker</h2>
      <p className="sub">{L.name} · {L.product} · {L.stages.length} development stages</p>
      <div className="panel">
        {/* key resets the filters when switching line, like the prototype */}
        <PartsTable key={L.id} list={lp} today={today} isAdmin={isAdmin} me={me} buyers={buyers}
          pre={pre} engFilter={isAdmin} mineFilter={!isAdmin} defaultMine={!isAdmin}
          onOpen={openPart} onAdvance={advance} />
      </div>
    </>
  );
};

export default DevelopmentTracker;
